import { USERS, LOADING, ACCESS } from './UsersActions';

const INITIAL_STATE = {
  loading: false,
  requestAccess: false,
  members: [],
  users: [],
  awaiting: [],
  page: 0,
  total: 0,
};

const UsersReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case USERS: {
      return {
        ...state,
        loading: false,
        users: action.data.results,
        awaiting: action.data.awaiting,
        page: action.data.page,
        total: action.data.total,
      };
    }
    case LOADING: {
      return {
        ...state,
        loading: action.val,
      };
    }
    case ACCESS: {
      return {
        ...state,
        requestAccess: action.val
      }
    }
  }

  return state;
};

export default UsersReducer;
